import { render, staticRenderFns } from "./BrainstormClusterItem.vue?vue&type=template&id=6c69925e&scoped=true&"
import script from "./BrainstormClusterItem.vue?vue&type=script&lang=js&"
export * from "./BrainstormClusterItem.vue?vue&type=script&lang=js&"
import style0 from "./BrainstormClusterItem.vue?vue&type=style&index=0&id=6c69925e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c69925e",
  null
  
)

export default component.exports